var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2752 17.7833C9.36686 17.7833 8.45853 17.4417 7.76686 16.75C6.38353 15.3667 6.38353 13.125 7.76686 11.7417L9.83353 9.68334C10.0752 9.44167 10.4752 9.44167 10.7169 9.68334C10.9585 9.925 10.9585 10.325 10.7169 10.5667L8.6502 12.625C7.75853 13.5167 7.75853 14.975 8.6502 15.8667C9.54186 16.7583 11.0002 16.7583 11.8919 15.8667L15.1335 12.625C16.1169 11.6417 16.6585 10.3333 16.6585 8.94167C16.6585 7.55 16.1169 6.24167 15.1335 5.25834C13.1002 3.225 9.80019 3.225 7.76686 5.25834L4.23353 8.79167C3.40853 9.61667 2.9502 10.7167 2.9502 11.8833C2.9502 13.05 3.40853 14.15 4.23353 14.975C4.4752 15.2167 4.4752 15.6167 4.23353 15.8583C3.99186 16.1 3.59186 16.1 3.3502 15.8583C2.29186 14.7917 1.7002 13.3833 1.7002 11.8833C1.7002 10.3833 2.28353 8.96667 3.3502 7.90834L6.88353 4.375C9.4002 1.85834 13.5002 1.85834 16.0169 4.375C17.2335 5.59167 17.9085 7.21667 17.9085 8.94167C17.9085 10.6667 17.2335 12.2917 16.0169 13.5083L12.7752 16.75C12.0835 17.4417 11.1835 17.7833 10.2752 17.7833Z",
    fill: "#007CB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6a2fdefd3967a2603fc99294060e0fe0.svg";
export { ForwardRef as ReactComponent };